export default __webpack_public_path__ + "static/media/so-logo.e8ebc8b2.png";